export default __webpack_public_path__ + "media/images/user_photos/163-9e8f74f836a0830775a55059ab8b45e0.jpg";